if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('t4s-modal__content')) {
                   BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
                   BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)
                   BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
                   BSS_B2B.makeChangesAfterClickAjaxCart(500)
                   BSS_B2B.observer.cartSubject.listenCartCheckout()
                   BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                   BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                   BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}

/**
 * SBCB2BBS-4351 - Custom 2-tier Quantity Increment for "TAPES" products
 * Store: 11zfc5-k9.myshopify.com (storefront-ts runtime)
 * Rule: qty 1-17 free (any integer), qty >= 18 must be a multiple of 18.
 * Patches QiUtils.prototype (shared by QiProduct/QiCart/QiProductList) so
 * product page, cart page and collection bulk-order rows all respect it.
 * Every rule other than the configured one keeps using the app's native logic.
 * Confirmed working on live PDP 2026-09-04 (real click trace).
 */
(function () {
    var SHOP_DOMAIN = '11zfc5-k9.myshopify.com';
    if (typeof window === 'undefined' || !window.Shopify || window.Shopify.shop !== SHOP_DOMAIN) return;
    if (!window.BSS_B2B || !window.BSS_B2B.qi) return;

    // Update this once the real "TAPES" QI rule is created (currently the test rule "BSS TEST").
    var TARGET_RULE_IDS = [8217];
    var FREE_MAX = 17;
    var STEP = 18;

    function isTargetRule(rule) {
        return !!rule && TARGET_RULE_IDS.indexOf(rule.id) !== -1;
    }

    function nextValid(q) {
        if (q < FREE_MAX) return q + 1;
        if (q === FREE_MAX) return STEP;
        return Math.floor(q / STEP) * STEP + STEP;
    }

    function prevValid(q) {
        if (q <= 1) return 1;
        if (q <= STEP) return q - 1;
        return q - STEP;
    }

    function nearestValid(q) {
        if (q < 1) return 1;
        if (q <= FREE_MAX) return Math.round(q);
        var remainder = q % STEP;
        if (remainder === 0) return q;
        return remainder >= STEP / 2 ? q + (STEP - remainder) : q - remainder;
    }

    function clamp(q, min, max) {
        if (q < min) q = min <= FREE_MAX ? min : Math.ceil(min / STEP) * STEP;
        if (q > max) q = max <= FREE_MAX ? max : Math.floor(max / STEP) * STEP;
        return q;
    }

    function patchProto(proto) {
        if (proto.__bssTapesQiPatched) return;
        var originalCalc = proto.calculateNearestQuantity;
        var originalCheck = proto.checkQuantity;

        proto.calculateNearestQuantity = function (rule, curQuantity, changeType) {
            if (!isTargetRule(rule)) return originalCalc.call(this, rule, curQuantity, changeType);
            var min = 1;
            var max = rule.qty_increment_max || Infinity;
            var result;
            if (changeType === 'UpQuantity') {
                result = nextValid(curQuantity);
            } else if (changeType === 'DownQuantity') {
                result = prevValid(curQuantity);
            } else {
                result = nearestValid(curQuantity);
            }
            return clamp(result, min, max);
        };

        proto.checkQuantity = function (rule, quantity) {
            if (!isTargetRule(rule)) return originalCheck.call(this, rule, quantity);
            var min = 1;
            var max = rule.qty_increment_max || Infinity;
            if (quantity < min || quantity > max) return false;
            if (quantity <= FREE_MAX) return true;
            return quantity % STEP === 0;
        };

        proto.__bssTapesQiPatched = true;
    }

    function fixInitialQuantities(instance) {
        if (!instance.product) return;
        try {
            var formIds = window.BSS_B2B.observer.productSubject.getProductFormIds();
            for (var formId of formIds.keys()) {
                var product = window.BSS_B2B.storage.productFormStorage.get(formId);
                if (!product || product.location === 'quick_order_list') continue;
                if (!isTargetRule(product.appliedQI)) continue;
                var productForm = document.querySelector(
                    '[' + window.BSS_B2B.enum.PRODUCT_FORM_ID + '="' + formId + '"]:not([bss-b2b-quick-order-product])'
                );
                var quantityInput = productForm ? window.BSS_B2B.utils.getQtyInputOnProductForm(productForm) : null;
                if (quantityInput) quantityInput.value = '0';
                instance.product.handleQuantityInputByFormId(formId, 'UpQuantity');
            }
        } catch (e) {}
    }

    function patchAndFix(instance) {
        var anyInstance = instance.product || instance.cart || instance.productList;
        if (!anyInstance) return;
        patchProto(Object.getPrototypeOf(anyInstance));
        fixInitialQuantities(instance);
    }

    var qi = window.BSS_B2B.qi;
    if (qi.utils) {
        patchAndFix(qi.utils);
    } else {
        var utilsVal;
        Object.defineProperty(qi, 'utils', {
            configurable: true,
            get: function () { return utilsVal; },
            set: function (instance) {
                utilsVal = instance;
                patchAndFix(instance);
            },
        });
    }
})();
